import Api from 'api'

const config = {
  baseURL: '/api/app/v1/stories',
}
const api = new Api(config)

api.fetchList = ({ ...rest }) => api.get('', { ...rest })
api.sendEvent = ({ ...rest }) => api.post('/events', { ...rest })

export default api
